import {
  mdiHomeOutline,
  mdiHistory,
  mdiAccountMultipleOutline,
  mdiWalletOutline,
  mdiPackageVariantClosed,
  mdiCarOutline,
  mdiMapMarkerPlusOutline,
  mdiHeadset,
  mdiTruckOutline,
  mdiClockOutline,
  mdiNoteTextOutline,
  mdiBookOpen,
} from "@mdi/js";

export default [
  {
    title: "Dashboards",
    icon: mdiHomeOutline,
    to: "dashboards",
  },
  {
    subheader: "REQUESTS",
  },
  {
    title: "Running trips",
    icon: mdiCarOutline,
    to: "runningTrips",
  },
  {
    title: "Rentals",
    icon: mdiClockOutline,
    to: "rentals",
  },
  {
    title: "Multistop",
    icon: mdiMapMarkerPlusOutline,
    to: "multiStop",
    module: "multiStop",
  },
  {
    title: "History",
    icon: mdiHistory,
    to: "history",
  },
  {
    subheader: "PARCELS",
  },
  {
    title: "Running parcels",
    icon: mdiPackageVariantClosed,
    to: "runningParcels",
    module: "parcel",
  },
  // {
  //   title: "Multiparadas ",
  //   icon: mdiMapMarkerPath,
  //   to: "parcelMultiStop",
  //   module: "parcel",
  // },
  {
    title: "History ",
    icon: mdiHistory,
    to: "parcelHistory",
    module: "parcel",
  },
  {
    subheader: "USERS",
  },
  {
    title: "Payroll",
    icon: mdiAccountMultipleOutline,
    to: "users",
  },
  {
    subheader: "FINANCIAL",
  },
  {
    title: "Balance",
    icon: mdiWalletOutline,
    to: "balance",
  },
  {
    title: "CorporateInvoices",
    icon: mdiNoteTextOutline,
    to: "corporateInvoices",
  },
  {
    subheader: "OTHERS",
  },
  {
    title: "cargo_logistics",
    icon: mdiTruckOutline,
    to: "cargoLogistics",
  },
  {
    subheader: "API",
  },
  {
    title: "Documentation",
    icon: mdiBookOpen,
    href: "https://api-partner-docs.ridery.app/introduccion.html",
    target: "_blank",
    rel: "noopener noreferrer",
    module: "api",
  },
  {
    subheader: "HELP",
  },
  {
    title: "Support",
    icon: mdiHeadset,
    href: "https://wa.me/message/XWIMSGXEF3LHA1",
    target: "_blank",
  },
];
